import { DatabaseIcon } from '@/src/assets/icons'
import { FlexRow } from '@/src/components'
import { Box, Text, Tooltip } from '@chakra-ui/react'
import type { FC } from 'react'

export const SEUTag: FC<{
  title: string
  truncate?: boolean
  maxChars?: number
  /** When set (e.g. `"100%"`), tag fills the cell; label truncates with ellipsis + tooltip instead of shrinking to content width. */
  width?: string
}> = ({ title, truncate = false, maxChars = 20, width }) => {
  const clamp = (str: string) => (str.length > maxChars ? str.slice(0, maxChars) + '…' : str)
  const fillCell = width != null && width !== ''

  const content = (
    <FlexRow
      width={fillCell ? width : 'fit-content'}
      minW={fillCell ? 0 : undefined}
      gap='4px'
      bg='#F3F3F3'
      padding='4px 8px'
      borderRadius='4px'
      alignItems='center'
      maxW={truncate && !fillCell ? '180px' : undefined}
    >
      <Box flexShrink={0} lineHeight={0}>
        <DatabaseIcon color='#404040' />
      </Box>
      <Text
        color='#404040'
        fontWeight={500}
        fontSize='12px'
        flex={fillCell ? 1 : undefined}
        minW={fillCell ? 0 : undefined}
        isTruncated={truncate}
        maxW={truncate && !fillCell ? '140px' : undefined}
      >
        {truncate && !fillCell ? clamp(title) : title}
      </Text>
    </FlexRow>
  )

  return truncate ? (
    <Tooltip label={title} bg='white' color='gray.800' fontWeight='normal' p='2' borderRadius='base' hasArrow placement='top'>
      {content}
    </Tooltip>
  ) : (
    content
  )
}
